export function isInactiveTenantResponse(error) {
  return (
    error?.response?.status === 403 &&
    String(error?.response?.data?.message || "")
      .toLowerCase()
      .includes("inactive")
  );
}
